/**
 * Legacy 后端 AJAX 封装（回调风格）。
 * 与 BaseCode 配合做 JSONP 参数 Base64 编码；新全效能力请优先用 coreapi.js。
 */
import $ from 'jquery'
import basecode from './BaseCode'
export default {
    get(url, data, callback_success, callback_error) {
        $.ajax({
            type: 'get',
            url,
            data,
            success: res => {
                callback_success(res)
            },
            error: err => {
                callback_error(err)
            }
        })
    },
    post(url, data, callback_success, callback_error) {
        $.ajax({
            type: 'post',
            url,
            data: JSON.stringify(data),
            success: res => {
                callback_success(res)
            },
            error: err => {
                callback_error(err)
            }
        })
    },
    postFile(url, data, callback_success, callback_error) {
        $.ajax({
            type: 'post',
            url,
            cache: false,
            contentType: false,
            processData: false,            
            data: data,
            success: res => {
                callback_success(res)
            },
            error: err => {
                callback_error(err)
            }
        })
    },
    /** JSONP：参数 JSON → UTF-8 → Base64 后拼进 URL 路径（legacy 接口约定） */
    normalJsonp(url, data, callback_success, callback_error) {
        data = basecode.base64encode(basecode.utf16to8(JSON.stringify(data)))
        $.ajax({
            type: 'get',
            url: url + '/' + data,
            dataType: 'jsonp',
            success: res => {
                callback_success(res)
            },
            error: err => {
                callback_error(err)
            }
        })
    },
    /** 大 payload 分片 JSONP 上传（历史商城接口，按 15KB 切片） */
    sliceRequest(url, data, callback_success, callback_error) {
        data = basecode.base64encode(basecode.utf16to8(JSON.stringify(data))) 

        var fileContent = data;
        var maxLentC = 15000;
        var AllLent = fileContent.length;
        var maxLent = parseInt(AllLent / maxLentC);
        var modeV = AllLent % maxLentC;
        var maxLent = (modeV == 0) ? maxLent : maxLent + 1;
        for (var i = 0; i < maxLent; i++) {
            var tmp = fileContent.substring(0, maxLentC);
            fileContent = fileContent.substring(maxLentC);
            var index = i.toString();
            var dap1 = {
                Content: tmp,
                Index: index,
                OnlyId: '23100',
                MaxLenth: maxLent,
                Menth: 'UpdateShop'
            };
            $.ajax({
                url,
                dataType: 'jsonp',
                type: 'get',
                data: JSON.stringify(dap1),
                success: res => {
                    callback_success(res)
                },
                error: err => {
                    callback_error(err)
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/baseajax.js